<template>

    <section class="max-w-screen-lg mx-auto w-full py-12 px-6">
        <div class="grid md:grid-cols-2 gap-24 items-start">
            <div>
                <img src="/images/business_login.png" alt="Business Login"
                    class="w-full h-auto object-contain max-h-80" />

                <div class="grid grid-cols-2 gap-2 mt-8">
                    <a href="https://docs.unified.to/auth/login/Sign_in_a_user"
                        class="text-blue-500 flex items-center gap-2">
                        Sign-in documentation
                        <Icon name="ic:round-keyboard-arrow-right" />
                    </a>
                    <a href="https://docs.unified.to/auth/saml/Sign_in_a_user_via_SAML"
                        class="text-blue-500 flex items-center gap-2">
                        SAML documentation
                        <Icon name="ic:round-keyboard-arrow-right" />
                    </a>
                </div>
            </div>
            <div class="space-y-6">
                <h2 class="text-4xl font-bold text-white">Business Login</h2>
                <p class="text-neutral-50">
                    Sign users in with the software their company already runs on. Redirect them to one Unified URL and
                    get back their verified email and name. No OAuth flows to build, no tokens to store.
                </p>

                <p class="text-neutral-50 mt-2">
                    Built on OpenID Connect (OIDC), OAuth2, and SAML specifications.

                </p>

                <p class="text-neutral-50 mt-2">
                    Unified supports <strong>{{ AUTH_INTEGRATIONS.length }}+ sign-in integrations</strong>.
                </p>


            </div>

        </div>
    </section>
</template>

<script lang="ts">
import { INTEGRATIONS } from '~~/services/integrations';

export default {
    setup() {
        return {
            AUTH_INTEGRATIONS: INTEGRATIONS.filter((i) => i.categories.includes('auth') || i.categories.includes('saml')),

        }
    }
}
</script>